import React from 'react';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMediaCdnUrl } from 'global/prismicUtils';

const LandingVideo = ({ slice }) => {
  const videoProps = {
    src: getMediaCdnUrl(slice.primary.video?.url),
    youtubeEmbedId: slice.primary.youtubeEmbedId,
    autoPlay: slice.primary.autoplay,
    loop: slice.primary.loop,
    muted: slice.primary.mute,
    controls: !(slice.primary.controls === false),
  };

  return (
    <ContentWrapper className="landing-video" customWidth="888px" slice={slice}>
      <VideoPlayer {...videoProps} />
    </ContentWrapper>
  );
};

export default LandingVideo;
